import { useSyncExternalStore } from "react";
import type { CustomerClass } from "@hisense/shared";

/**
 * Công ty đang xem (yêu cầu v1.8 mục 1.1, 11/10/2026): Tất cả / Việt Nam / Trung Quốc cho tài khoản thấy cả hai công ty.
 *
 * Kho nhỏ ngoài React để `apiFetch` (tầng fetch, không có hook) đọc được và gửi header `X-Data-Region` ở MỌI yêu cầu — máy chủ thu hẹp
 * phạm vi qua đúng một bộ giải (`customerRegion`). Nhớ theo từng người dùng trong localStorage (tiện cho người dùng, không phải quyền:
 * máy chủ vẫn tự kiểm `canSwitchRegion`). localStorage bị chặn thì vẫn chạy, chỉ không nhớ qua lần tải lại.
 */
let userKey: string | null = null;
let region: CustomerClass | null = null;
const listeners = new Set<() => void>();
const storageKey = (id: string) => `hisense.viewRegion.${id}`;

function emit() {
  for (const l of listeners) l();
}

/** Gọi khi biết người dùng (đăng nhập / tải trang). `canSwitch` = được thấy cả hai công ty. */
export function bindViewRegionUser(userId: string | null, canSwitch: boolean) {
  const nextKey = userId && canSwitch ? userId : null;
  let next: CustomerClass | null = null;
  if (nextKey) {
    try {
      const saved = window.localStorage.getItem(storageKey(nextKey));
      next = saved === "vietnam" || saved === "china" ? saved : null;
    } catch {
      next = null;
    }
  }
  if (nextKey === userKey && next === region) return;
  userKey = nextKey;
  region = next;
  emit();
}

export function setViewRegion(next: CustomerClass | null) {
  if (!userKey) return;
  region = next;
  try {
    if (next) window.localStorage.setItem(storageKey(userKey), next);
    else window.localStorage.removeItem(storageKey(userKey));
  } catch {
    /* chặn bộ nhớ — vẫn đổi trong phiên này */
  }
  emit();
}

/** Cho `apiFetch`: header gửi kèm, hoặc null khi đang xem tất cả. */
export const getViewRegion = () => region;

export function useViewRegion(): CustomerClass | null {
  return useSyncExternalStore(
    (l) => {
      listeners.add(l);
      return () => listeners.delete(l);
    },
    () => region,
    () => null,
  );
}
